export const IssueStatusValidation = (formData) => {
    const errors = {};
  
    // Validate each field
    if (!formData.StatusName.trim()) {
      errors.StatusName = 'Status Name is required';
    } 
   
    return errors;
  };
  
 